import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../astrologerregistration/astrologerregistration.css";
import APIURL from "../../common/Config";
import ApiManager from "../../api-manager/ApiManager.component";
import LocalDBApi from "../../api-manager/LocalDBManager.component";
import Header from "../header/header";
import Footer from "../footer/footer";

const AstrologerForm = () => {
  const [fullName, setFullName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("Male");
  const [address, setAddress] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [email, setEmail] = useState("");
  const [experience, setExperience] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [languages, setLanguages] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [validationErrors, setValidationErrors] = useState({
    fullName: "",
    age: "",
    email: "",
    pincode: "",
    experience: "",
    languages: "",
  });

  useEffect(() => {
    const phone = LocalDBApi.getFromLocalStorage("phoneNumber");
    if (phone) setMobileNo(phone);
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${APIURL}/api/country/countryList`);
        if (Array.isArray(response.data)) {
          setCountryData(
            response.data.map((c) => ({ id: c.id, name: c.country_name }))
          );
        }
      } catch (error) {
        console.error("Country API Error:", error);
      }
    };
    fetchCountries();
  }, []);

  const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    setCountry(selectedCountry);
    setState("");
    setCity("");
    try {
      const response = await axios.get(
        `${APIURL}/api/states/${selectedCountry}`
      );
      if (Array.isArray(response.data)) {
        setStateData(
          response.data.map((s) => ({ id: s.state_id, name: s.state_name }))
        );
      }
    } catch (error) {
      console.error("State API Error:", error);
    }
  };

  const handleStateChange = async (e) => {
    const selectedState = e.target.value;
    setState(selectedState);
    setCity("");
    try {
      const response = await axios.get(`${APIURL}/api/cities/${selectedState}`);
      if (Array.isArray(response.data)) {
        setCityData(
          response.data.map((city) => ({
            id: city.city_id,
            name: city.city_name.trim(),
          }))
        );
      }
    } catch (error) {
      console.error("City API Error:", error);
    }
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const validatePincode = (pincode) => {
    const re = /^[0-9]{6}$/;
    return re.test(pincode);
  };

  const validateFullName = (name) => {
    return name.trim().length >= 3;
  };

  const validateAge = (age) => {
    const ageNum = parseInt(age);
    return !isNaN(ageNum) && ageNum >= 18 && ageNum <= 100;
  };

  const validateExperience = (exp) => {
    const expNum = parseInt(exp);
    return !isNaN(expNum) && expNum >= 0 && expNum <= 70;
  };

  const handleFullNameChange = (e) => {
    const value = e.target.value;
    setFullName(value);

    setValidationErrors((prev) => ({ ...prev, fullName: "" }));

    if (value && !validateFullName(value)) {
      setValidationErrors((prev) => ({
        ...prev,
        fullName: "Name should be at least 3 characters long",
      }));
    }
  };

  const handleAgeChange = (e) => {
    const value = e.target.value;
    setAge(value);

    setValidationErrors((prev) => ({ ...prev, age: "" }));

    if (value && !validateAge(value)) {
      setValidationErrors((prev) => ({
        ...prev,
        age: "Age must be between 18 and 100",
      }));
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    setValidationErrors((prev) => ({ ...prev, email: "" }));

    if (value && !validateEmail(value)) {
      setValidationErrors((prev) => ({
        ...prev,
        email: "Please enter a valid email address",
      }));
    }
  };

  const handlePincodeChange = (e) => {
    const value = e.target.value;
    setPincode(value);

    setValidationErrors((prev) => ({ ...prev, pincode: "" }));

    if (value && !validatePincode(value)) {
      setValidationErrors((prev) => ({
        ...prev,
        pincode: "Pincode must be 6 digits",
      }));
    }
  };

  const handleExperienceChange = (e) => {
    const value = e.target.value;
    setExperience(value);

    setValidationErrors((prev) => ({ ...prev, experience: "" }));

    if (value && !validateExperience(value)) {
      setValidationErrors((prev) => ({
        ...prev,
        experience: "Experience must be between 0 and 70 years",
      }));
    }
  };

  const handleLanguagesChange = (e) => {
    const value = e.target.value;
    setLanguages(value);

    setValidationErrors((prev) => ({ ...prev, languages: "" }));

    if (value && value.trim().length < 2) {
      setValidationErrors((prev) => ({
        ...prev,
        languages: "Please enter valid languages",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {
      fullName: !validateFullName(fullName)
        ? "Name should be at least 3 characters long"
        : "",
      age: !validateAge(age) ? "Age must be between 18 and 100" : "",
      email: !validateEmail(email) ? "Please enter a valid email address" : "",
      pincode: !validatePincode(pincode) ? "Pincode must be 6 digits" : "",
      experience: !validateExperience(experience)
        ? "Experience must be between 0 and 70 years"
        : "",
      languages:
        languages.trim().length < 2 ? "Please enter valid languages" : "",
    };

    setValidationErrors(errors);

    if (Object.values(errors).some((error) => error !== "")) {
      return;
    }

    setLoading(true);
    setError("");

    const astrologerData = {
      astrologerId: 0,
      mobileNo,
      emailId: email,
      status: 1,
      firstName: fullName,
      gender,
      age: parseInt(age) || 0,
      language: languages,
      specialization,
      experience: parseInt(experience) || 0,
      registrationDate: new Date().toISOString(),
      address,
      country,
      state,
      city,
      pinCode: parseInt(pincode) || 0,
    };

    LocalDBApi.saveMsisdnToLocalStorage(mobileNo);
    LocalDBApi.saveUserTypeToLocalStorage("ASTROLOGER");
    localStorage.setItem("astrologerData", JSON.stringify(astrologerData));

    try {
      const response = await ApiManager.registerAsAstrologer(astrologerData);
      if (response.astrologerId) {
        ApiManager.storeData("ASTROLOGERID", response.astrologerId);
        LocalDBApi.saveUserTypeToLocalStorage("ASTROLOGER");

        navigate("/bank-details");
      }
    } catch (error) {
      console.error("Registration failed:", error);
      setError("Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const ErrorMessage = ({ message }) => {
    return message ? (
      <div
        className="validation-error"
        style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
      >
        {message}
      </div>
    ) : null;
  };

  return (
    <div>
      <Header />
      <div className="registration-form">
        <form onSubmit={handleSubmit}>
          <h2>Register as Astrologer</h2>

          <div className="form-group">
            <label>
              Full Name <span className="required-field">*</span>
            </label>
            <input
              type="text"
              value={fullName}
              onChange={handleFullNameChange}
              required
            />
            <ErrorMessage message={validationErrors.fullName} />
          </div>

          <div className="form-group">
            <label>Mobile Number</label>
            <input type="text" value={mobileNo} readOnly />
          </div>

          <div className="form-group">
            <label>
              Age <span className="required-field">*</span>
            </label>
            <input
              type="number"
              value={age}
              onChange={handleAgeChange}
              required
            />
            <ErrorMessage message={validationErrors.age} />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select value={gender} onChange={(e) => setGender(e.target.value)}>
              <option>Male</option>
              <option>Female</option>
              <option>Non-Binary</option>
              <option>Prefer Not to Say</option>
            </select>
          </div>

          <div className="form-group">
            <label>Address</label>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Country</label>
            <select value={country} onChange={handleCountryChange} required>
              <option value="">Select Country</option>
              {countryData.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          {country && (
            <div className="form-group">
              <label>State</label>
              <select value={state} onChange={handleStateChange} required>
                <option value="">Select State</option>
                {stateData.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {state && (
            <div className="form-group">
              <label>City</label>
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
              >
                <option value="">Select City</option>
                {cityData.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>
              Pincode <span className="required-field">*</span>
            </label>
            <input
              type="text"
              value={pincode}
              onChange={handlePincodeChange}
              required
            />
            <ErrorMessage message={validationErrors.pincode} />
          </div>

          <div className="form-group">
            <label>
              Email <span className="required-field">*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
            />
            <ErrorMessage message={validationErrors.email} />
          </div>

          <div className="form-group">
            <label>
              Languages <span className="required-field">*</span>
            </label>
            <input
              type="text"
              value={languages}
              onChange={handleLanguagesChange}
              required
              placeholder="Hindi, English, etc."
            />
            <ErrorMessage message={validationErrors.languages} />
          </div>

          <div className="form-group">
            <label>
              Experience (in years) <span className="required-field">*</span>
            </label>
            <input
              type="number"
              value={experience}
              onChange={handleExperienceChange}
              required
            />
            <ErrorMessage message={validationErrors.experience} />
          </div>

          {/* <div className="form-group">
            <label>Specialisation</label>
            <select
              value={specialization}
              onChange={(e) => setSpecialization(e.target.value)}
            >
              <option value="vedic">Vedic</option>
              <option value="numerology">Numerology</option>
              <option value="tarot">Tarot</option>
            </select>
          </div> */}
          <div className="form-group">
            <label>Specialisation</label>
            <input
              type="text"
              value={specialization}
              onChange={(e) => setSpecialization(e.target.value)}
              placeholder="Enter your specialisation (Vedic,Tarot,etc.)"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading}>
            {loading ? "Registering..." : "Register"}
          </button>
        </form>
      </div>
      <Footer />

      <style jsx="true">{`
        .required-field {
          color: red;
          margin-left: 2px;
        }

        .validation-error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      `}</style>
    </div>
  );
};

export default AstrologerForm;
